import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

export async function fetchMemberDashboard() {
  const res = await fetch(`${API_BASE}/api/member/dashboard`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل لوحة التحكم'));
  return data;
}
